import CollapseTransition from '../transition/collapse';

export default CollapseTransition;